"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDismissNotificationMutation = exports.useMarkAsReadMutation = exports.useFetchNotificationsQuery = exports.notificationApi = void 0;
var react_1 = require("@reduxjs/toolkit/query/react");
var baseQueryWithReauth_1 = require("../../utils/baseQueryWithReauth");
exports.notificationApi = (0, react_1.createApi)({
    reducerPath: "notificationApi",
    baseQuery: (0, baseQueryWithReauth_1.baseQueryWithReauth)(process.env.LETS_CUE_API),
    tagTypes: ["notifications"],
    endpoints: function (builder) { return ({
        fetchNotifications: builder.query({
            query: function (obj) { return ({
                url: "/v1/notification/all",
                method: "GET",
                params: { clientId: obj.clientId, limit: obj.limit || 50 },
            }); },
            providesTags: ["notifications"],
        }),
        markAsRead: builder.mutation({
            query: function (obj) { return ({
                url: "/v1/notification/read",
                method: "PUT",
                body: obj,
            }); },
            invalidatesTags: ["notifications"],
        }),
        dismissNotification: builder.mutation({
            query: function (obj) { return ({
                url: "/v1/notification/dismiss",
                method: "PUT",
                body: obj,
            }); },
            invalidatesTags: ["notifications"],
        }),
    }); },
});
exports.useFetchNotificationsQuery = exports.notificationApi.useFetchNotificationsQuery, exports.useMarkAsReadMutation = exports.notificationApi.useMarkAsReadMutation, exports.useDismissNotificationMutation = exports.notificationApi.useDismissNotificationMutation;
